import type {OrderOptions} from '@github-ui/dashboard-sorting-dropdown/SortingDropdown'

export const DEFAULT_SORTING_KEY = 'updated'

export const defaultSortingOptions: Record<string, OrderOptions> = {
  created: {label: 'Created on', defaultDirection: 'desc'},
  updated: {label: 'Last updated', defaultDirection: 'desc'},
  comments: {label: 'Total comments', defaultDirection: 'desc'},
  relevance: {label: 'Best match', defaultDirection: undefined},
}
